import { useQuery } from '@tanstack/react-query'

import { queries } from '~/features/partners/utils'

const useGetPartnerConfigByDomain = (enabled: boolean) => {
  return useQuery(queries.partnerByDomain(enabled))
}

export default useGetPartnerConfigByDomain
